// import './bootstrap'
import '@mdi/font/css/materialdesignicons.css'

import Vue from 'vue'
import VueRouter from 'vue-router'
import Vuelidate from 'vuelidate'
import VuelidateErrorExtractor, { templates } from 'vuelidate-error-extractor'
import routes from './routes'
import mixin from './mixins'
import FormSummary from './components/ErrorGroupSummary.vue'
import FormGroup from './components/FormGroup.vue'
import ValidationErrorMessages from './common/ValidationErrorMessages.json'
import ValidationAttributes from './common/ValidationAttributes.json'
import yesno from './filters/yesno'
import Vuetify from 'vuetify'
import light from './theme'
import VueLocalStorage from 'vue-localstorage'
import Util from './helpers/Util'

Vue.use(VueRouter)
Vue.mixin(mixin)
Vue.use(Vuelidate)
Vue.use(VuelidateErrorExtractor, {
  template: FormGroup,
  messages: ValidationErrorMessages,
  attributes: ValidationAttributes
})
Vue.use(Vuetify)
Vue.use(VueLocalStorage)
Vue.component('form-error-summary', FormSummary)
Vue.component('form-wrapper', templates.FormWrapper)
Vue.filter('yesno', yesno)
Vue.prototype.$auth = window.Auth

if (window.Auth) {
  if (window.Auth.company.use_stripe_for_subscriptions) {
    Vue.prototype.$legacy = true
  } else {
    Vue.prototype.$legacy = false
  }

  if (window.Auth.company.enable_claims) {
    Vue.prototype.$enableClaims = true
  } else {
    Vue.prototype.$enableClaims = false
  }

  if (window.Auth.company.show_auto_renew_checkbox) {
    Vue.prototype.$showAutoRenewCheckbox = true
  } else {
    Vue.prototype.$showAutoRenewCheckbox = false
  }

  Vue.prototype.$company = window.Auth.company
  Vue.prototype.$defaultLocation = window.Auth.default_office_location_id
}

const Router = new VueRouter(routes)

const app = new Vue({
  el: '#app',
  router: Router,
  vuetify: new Vuetify({
    icons: {
      iconfont: 'mdi'
    },
    theme: {
      themes: { light }
    }
  })
})
